import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IConfirm } from 'src/app/interfaces/confirm';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { CourseService } from 'src/app/services/http/business/course/course.service';

@Component({
  selector: 'app-student-private-class-request',
  templateUrl: './student-private-class-request.component.html',
  styleUrls: ['./student-private-class-request.component.css']
})
export class StudentPrivateClassRequestComponent implements OnInit {

  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "no",
    "date",
    "name",
    "phone",
    "package",
    "days",
    "branch",
    "timeStart",
    "timeEnd",
    "sessionCount",
    "function"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private translate: TranslateService,
    private courseService: CourseService,
  ) { }

  ngOnInit() {
    this.requestList();
  }

  requestList() {
    this.courseService.getPrivateClassRequestForAdmin().subscribe(res => {
      this.dataSource = null;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.courseService.getPrivateClassRequestForAdmin(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  reviewed(requestId: number) {
    var command = {
      xPrivateClassRequestId: requestId
    }

    let confirm: IConfirm = {
      accept: true,
      message: "آیا از تغییر وضعیت درخواست اطمینان دارید؟",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "300px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.courseService.SetPrivateClassRequestReviewed(command).subscribe(() => {
            this.snackBar.OpenSnackBar(
              "وضعیت با موفقیت تغییر کرد.",
              "ok",
              3000,
              SoundEnum.beep
            );
            this.paginatorEvent(this.paginator);
          });
        }
      });
  }

  getDays(days: string) {
    return days.split(',');
  }

}
